define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/xml",
	"csi/view/ToolbarPluginMenu"
], function(array,declare,xml,ToolbarPluginMenu) {

	return declare(ToolbarPluginMenu, {
		validatePlugin: function(/*Context*/ctx) {
			// summary: only allow if Sample.Dimensions is valid, has Write right on the sample, and the Sample's Size is on the SizeChartRevision.Sizes list
			var	sample = ctx ? ctx.getParent() : null;
			var bShowAction = sample && xml.nodeHasRight(sample, xml.RIGHT_WRITE) && xml.isValidURL(sample.Dimensions);
			
			if(bShowAction) { 
				// Enable only if the Sample's Size (Sample.ProductSize) is on the SizeChartRevision.Sizes list
				var sampleSize = sample.ProductSize;
				var sizeChartRev = ctx.view.viewParent.getSizeChartRevision();
				bShowAction = (xml.isValidURL(sampleSize) && sizeChartRev) ? this._sizeIsInSizeChart(sizeChartRev, sampleSize) : false;
			}

			this._setDisabled(this, !bShowAction);  // enable the action even the parent view is readonly
			return !!bShowAction;
		},

		_sizeIsInSizeChart: function(/*Node*/ sizeChartRev, /*String*/ sampleSizeUrl) {
			// summary: return if the Sample's Size sampleSizeUrl is on the SizeChartRevision.Sizes list
			return array.indexOf(sizeChartRev.Sizes, sampleSizeUrl) >= 0;
		}
	});
});